<!-- Only show for candidate (non-admin) URLs -->
<ng-container *ngIf="!isAdmin">
  <!-- Floating Robot Icon -->
  <img *ngIf="!isChatOpen" src="assets/img/chatbot.svg" alt="Chat" class="floating-btn" (click)="toggleChat()" title="Chat with us">

  <!-- Floating Chat Panel -->
  <div class="chat-panel" *ngIf="isChatOpen">
    <!-- Top Action Buttons -->
    <div class="top-actions">
      <button class="btn btn-close-chat" (click)="toggleChat()">
        X&nbsp; Close
      </button>
      <button class="btn btn-action" (click)="startAgain()" [disabled]="!chatHistory?.length || loading">
        Start Again
      </button>
      <button class="btn btn-action" (click)="showAskPersonModal = true">
        Ask a Person
      </button>
    </div>

    <!-- Shimmer Loader -->
    <ng-container *ngIf="displayLoader">
      <div class="loader-container">
        <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8]">
          <li class="t_loader">
            <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
          </li>
        </ng-container>
      </div>
    </ng-container>

    <!-- Chat Content Area -->
    <div *ngIf="!displayLoader" class="chat-content" #chatContent>
<div *ngFor="let item of chatHistory" class="message-pair">
        <!-- User Message (left, light) -->
        <div class="user-message">
          <div class="message-bubble user-bubble">
            {{ item.question }}
          </div>
        </div>
        <!-- Bot Response (right, blue) -->
        <div class="bot-message" *ngIf="item.answer || item.isLoading">
          <div class="message-bubble bot-bubble">
            <ng-container *ngIf="item.isLoading">
              <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </ng-container>
            <ng-container *ngIf="!item.isLoading">
              <p [innerHTML]="formatAnswer(item.answer)"></p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Input Area -->
    <div *ngIf="!displayLoader" class="input-container">
      <div class="input-wrapper">
        <textarea [(ngModel)]="userQuestion"
                  placeholder="How can I help you!"
                  class="form-control custom-input"
                  (keyup.enter)="askQuestion()"
                  [disabled]="loading"
                  rows="2"></textarea>
        <div class="input-actions">
          <button class="send-button" (click)="askQuestion()" [disabled]="loading || !userQuestion.trim()">
            <ng-container *ngIf="loading">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat spinning" viewBox="0 0 16 16">
                <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
              </svg>
            </ng-container>
            <ng-container *ngIf="!loading">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" fill="currentColor" class="bi bi-arrow-up-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5" />
              </svg>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Ask a Person Modal Overlay (outside chat-panel to avoid overflow clipping) -->
  <div class="modal-overlay" *ngIf="showAskPersonModal" (click)="closeAskPersonModal()">
    <div class="modal-box" (click)="$event.stopPropagation()">
      <div class="modal-header-custom">
        <h5 class="modal-title-custom">Ask a Person</h5>
        <button class="modal-close" (click)="closeAskPersonModal()">&times;</button>
      </div>
      <hr style="margin: 0;">
      <div class="modal-body-custom">
        <div *ngIf="askPersonMessage" class="modal-message" [ngClass]="{'message-success': askPersonMessageType === 'success', 'message-error': askPersonMessageType === 'error'}">
          {{ askPersonMessage }}
        </div>

        <ng-container *ngIf="askPersonMessageType !== 'success'">
          <label class="modal-label">Which department is your question for?</label>
          <div class="custom-select-wrapper">
            <div class="custom-select-trigger" (click)="showDeptDropdown = !showDeptDropdown">
              {{ askPersonDepartment || 'Select a department' }}
              <span class="custom-select-arrow">&#9662;</span>
            </div>
            <div class="custom-select-options" *ngIf="showDeptDropdown">
              <div class="custom-select-option" (click)="askPersonDepartment = 'Payroll'; showDeptDropdown = false">Payroll</div>
              <div class="custom-select-option" (click)="askPersonDepartment = 'Recruiting'; showDeptDropdown = false">Recruiting</div>
              <div class="custom-select-option" (click)="askPersonDepartment = 'Safety'; showDeptDropdown = false">Safety</div>
            </div>
          </div>

          <label class="modal-label mt-3">What is your question?</label>
          <textarea class="form-control" [(ngModel)]="askPersonQuestion" placeholder="Enter your question" rows="4"></textarea>
        </ng-container>
      </div>
      <div class="modal-footer-custom">
        <ng-container *ngIf="askPersonMessageType !== 'success'">
          <button class="btn btn-submit" (click)="submitAskPerson()" [disabled]="submittingAskPerson || !askPersonDepartment || !askPersonQuestion.trim()">
            {{ submittingAskPerson ? 'Submitting...' : 'Submit' }}
          </button>
        </ng-container>
        <button class="btn btn-close-modal" (click)="closeAskPersonModal()">Close</button>
      </div>
    </div>
  </div>
</ng-container>
